import { render, staticRenderFns } from "./orderChecklistItem.vue?vue&type=template&id=70546a79&"
import script from "./orderChecklistItem.vue?vue&type=script&lang=js&"
export * from "./orderChecklistItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports